import { Drawer, DrawerOverlay, DrawerContent } from "@chakra-ui/react";
import React, { useEffect } from "react";
import styles from "../../../pages/ai-tutor/Doubt/summary-list.module.css";
import { useRoot } from "../../../context/RootContext";
import PracticeHistoryList from "./PracticeHistoryList";

export default function PracticeHistoryBottomSheet(props) {
  useEffect(() => {}, []);
  const { openPracSideMenu, togglePracDrawer } = useRoot();

  return (
    <Drawer
      placement={"bottom"}
      onClose={() => {
        togglePracDrawer();
      }}
      isOpen={openPracSideMenu}>

      <DrawerOverlay />
      <DrawerContent
        sx={{ bgColor: "white" }}
        className={styles["summary-sheet"]}>

        <PracticeHistoryList />
      </DrawerContent>
    </Drawer>);

}